window.jQuery = window.$ = require("jquery");
require("./thirdParty/mqRes.min");
window.mqRespond = require("./mqRespond").init();

var processInclude = require("./util");

const $cache = {
    document: $(document)
};

processInclude(require("./dataLayer/sitewide").initDataLayerEvents());

const __oldAjax = $.ajax;

$.ajax = (opts) => {
    return __oldAjax({
        ...opts,
        error: function (err) {
            if (err && err.responseJSON && err.responseJSON.csrfError) {
                $("#session-lost-login-modal").modal("show");
                $.spinner().stop();
                return;
            }

            opts && opts.error && opts.error(err);
        }
    });
};

$cache.document.ready(function () {
    processInclude(require("./components/header").init());
    processInclude(require("./components/formElementsUtil").init());
    processInclude(require("./components/adsUtil").init());
    processInclude(require("./components/modalState"));
    processInclude(require("./components/modal"));
    processInclude(require("./components/coverageArea").init());
    processInclude(require("./utilities/globalUtilities").globalUtilInit());
    processInclude(require("./utilities/globalEvents").initEvents());

    processInclude(require("./components/navigation").initEvents());
    processInclude(require("./components/cookie"));
    processInclude(require("./components/consentTracking"));
    processInclude(require("./components/footer"));
    processInclude(require("./components/miniCart").init());
    processInclude(require("./components/collapsibleItem"));
    processInclude(require("./components/search"));
    processInclude(require("./components/clientSideValidation"));
    processInclude(require("./components/toolTip"));
    processInclude(require("./components/initSpecificQtyComponents").initQtyComponents());
    processInclude(require("./product/quickView"));
    processInclude(require("./components/backButton"));
    processInclude(require("./components/modalHelp").initModalHelp());
    processInclude(require("./wishlist/wishlist").initWishlist());

    processInclude(require("./dataLayer/quickView"));
    processInclude(require("./dataLayer/addToCart"));
    processInclude(require("./dataLayer/interconnection"));
    processInclude(require("./dataLayer/addToWishlist"));
    processInclude(require("./dataLayer/searchSuggestions"));
    processInclude(require("./dataLayer/loyaltyCard"));
    processInclude(require("./dataLayer/deliveryArea"));
    processInclude(require("./dataLayer/messages"));
    processInclude(require("./dataLayer/ipaper"));
    processInclude(require("./kevel/audience").initKevelAudienceEvents());
    processInclude(require("./utilities/dynamicImports").initDynamicImports());
    processInclude(require("./kevel/kevelBanners").init());
});

/**
 * Create custom event for form fields validation to be used on callback functions
 */
$cache.document.on("initFormValidation", function () {
    processInclude(require("./components/clientSideValidation"));
});

require("./thirdParty/bootstrap");
require("./thirdParty/slick.min");
require("./thirdParty/jquery-mTab-min");

require("./components/spinner");
require("simplebar");
require("jquery-mask-plugin");
